export default {
  avhandlingar: 'avhandling',
  lansstyrelserapporter: 'Lans_rapp',
  'ovriga-rapporter': 'orap',
  'mc-rapporter': 'MC-rapport',
  havsutsiktsartiklar: 'Havsutsikt',
  svealandsrapporter: 'svealandskusten',
}

export const reportTypeUrls = {
  avhandling: 'avhandlingar',
  Lans_rapp: 'lansstyrelserapporter',
  orap: 'ovriga-rapporter',
  'MC-rapport': 'mc-rapporter',
  Havsutsikt: 'havsutsiktsartiklar',
  svealandskusten: 'svealandsrapporter',
}

export const sections = [
  {
    id: 0,
    name: 'avhandling',
    title: 'Avhandlingar',
    label: 'avhandlingarna',
    singelLabel: 'Avhandling',
  },
  {
    id: 1,
    name: 'Lans_rapp',
    title: 'Länsstyrelserapporter',
    label: 'länsstyrelserapporterna',
    singelLabel: 'Länsstyrelserapport',
  },
  {
    id: 2,
    name: 'orap',
    title: 'Övriga rapporter',
    label: 'övriga rapporterna',
    singelLabel: 'Rapport (övrig)',
  },
  {
    id: 3,
    name: 'MC-rapport',
    title: 'MC-rapporter',
    label: 'MC-rapporterna',
    singelLabel: 'MC-rapport',
  },
  {
    id: 4,
    name: 'Havsutsikt',
    title: 'Havsutsiktsartiklar',
    label: 'havsutsiktsartiklarna',
    singelLabel: 'Havsutsiktartikel',
  },
  {
    id: 5,
    name: 'svealandskusten',
    title: 'Svealandskusten',
    label: 'svealandsrapporterna',
    singelLabel: 'Svealandsrapporter',
  },
]
